var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_vm._v(" 授权中，请稍后... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }